var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("chip", {
        attrs: {
          status: _vm.status.name,
          color: _vm.status.color,
          icon: _vm.status.icon,
          description: "clique para saber mais",
          statuses: _vm.statuses
        },
        on: {
          click: function($event) {
            _vm.showStatuses = true
          }
        }
      }),
      _vm._v(" "),
      _c("statuses", {
        attrs: {
          orderActive: _vm.status.order,
          statuses: _vm.statuses,
          visible: _vm.showStatuses
        },
        on: {
          close: function($event) {
            _vm.showStatuses = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8501b3d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8501b3d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Users/Status/Index.vue
// module id = null
// module chunks = 